import React, { useEffect, useState } from "react";
import {
  ConfigProvider,
  Row,
  Col,
  Image,
  Card,
  Layout,
  List,
  Button,
  Skeleton,
  Modal,
  Typography,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const DoubleButton = () => {
  let navigate = useNavigate();

    const RouteToLogin = () => {
        window.location.href = "https://dev-54fijlboquue4icc.us.auth0.com/samlp/CTuu15wvugEc7LRlqvXPINAcoZ8yry5u";
    }

    const RouteToHappy5 = () => {
        window.location.href = "https://dev-54fijlboquue4icc.us.auth0.com/samlp/zyrisuOlRWekrSH0O9uVV3XkAlTa65cG";
    }

    return(
        <>
            <div style={{
                width:"100%",
                height:"100vh",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column"
            }}>
                <Button onClick={RouteToLogin} size={"large"} style={{marginBottom:20}}>
                    MoLeawiz Web
                </Button>
                <Button onClick={RouteToHappy5} size={"large"}>
                    Happy5
                </Button>
            </div>
        </>
    )
}

export default DoubleButton;